import { combineReducers } from "redux";
import TokenReducer from './tokenReducer';
import leadFormReducer from './leadFormReducer';
import publishReducer from './publishReducer';
import surveyFormReducer from './surveyFormReducer';
// import { persistReducer } from 'redux-persist'
// import storage from 'redux-persist/lib/storage'
import surveyFieldDataReducer from './surveyFieldDataReducer ';

const moduleReducer = () => {
    return combineReducers({
        TokenReducer,
        leadFormData: leadFormReducer,
        publishData: publishReducer,
        showLandingPage: publishReducer,
        surveyData: surveyFormReducer,
        surveyFieldData: surveyFieldDataReducer
    });
};

export default moduleReducer;
